<div class="flex flex-col p-8 text-xl gap-10">
	<div>
		<iframe
			class="w-full h-[38rem] border border-gray-200"
			width="1080px"
			height="608px"
			src="https://www.youtube.com/embed/2TNdYdO8W1E?autoplay=1&mute=1&vq=hd720&si=ay-N_6F3pZe0I5KV"
			title="YouTube video player"
			frameborder="0"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
			referrerpolicy="strict-origin-when-cross-origin"
			allowfullscreen
		></iframe>
	</div>
	<div class="w-full flex justify-center border-t border-gray-200 pt-5">
		<ui-button
			classes="px-4 py-2 text-lg"
			label="Continue"
			(click)="goToConnectToCloserScreen()"
		></ui-button>
	</div>
</div>
